module.exports = __webpack_public_path__ + "img/icash.2e80d8f1.png";